import { IGetEventsDetailsResponse } from "../models";
import { convertTimeToMinutes } from "./date-time.service";
import * as _ from 'lodash';
import moment from 'moment';

interface INewGetEventsDetailsResponse extends IGetEventsDetailsResponse {
  isFavorite: boolean
}

const selectedTrackType = (type: number, selected?: string[], countryCode?: string): boolean => {

  let result: boolean = false;
  let trackTypeIs: string = '';

  switch(type) {
    // Quarterhorse included based on frontend repo
    case 1:
      trackTypeIs = 'Thoroughbred';
      break;

    case 2:
      trackTypeIs = 'Greyhound';
      break;

    case 3:
      trackTypeIs = 'Quarterhorse';
      break;

    case 4:
      trackTypeIs = 'Harness';
      break;
  }

  // !type &&
  if (
    (countryCode === null || countryCode !== 'US') &&
    !selected?.includes('International')
  ) {
    return result;
  }

  if (
    countryCode !== null &&
    countryCode !== 'US' &&
    selected?.includes('International')
  ) {
    trackTypeIs = 'International';
  }

  if (selected?.includes(trackTypeIs)) {
    result = true;
  }

  return result;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sortEvents = (
  allEvents: IGetEventsDetailsResponse[],
  sortBy?: string,
  trackType?: string[],
  listFavorites?: Set<string>
): any => {
  // console.log('sortEvents:allEvents:1', allEvents)
  const today = moment().utc();

  let newListEvent: INewGetEventsDetailsResponse[] = [];

  // identify event if favorite
  allEvents = _.map(allEvents, (event) =>
    event = {
      ...event,
      isFavorite: listFavorites?.has(event.id as string) || undefined
    } as IGetEventsDetailsResponse
  );

  if (sortBy === 'MTP') {
    const newListEventFn = (isFavorite?: boolean) =>
      _.concat(
        _.orderBy(
          // open - MTP - Today
          _.filter(allEvents, (event: INewGetEventsDetailsResponse) =>
            event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus === 0
            && moment(event?.ToteResponse?.EventDetail?.currentRace?.PostTime+'Z')
              .isSame(today, 'day')
            && convertTimeToMinutes(event?.ToteResponse?.EventDetail?.currentRace?.PostTime+'Z') <= 60
            && selectedTrackType(
              event?.ToteResponse?.EventDetail?.TrackType, trackType, event?.CountryCode
            ) === true
            && event?.isFavorite === isFavorite
          ),
          ['ToteResponse.EventDetail.currentRace.PostTime'],
          ['asc']
        ),
        _.orderBy(
          // open - Time - Today
          _.filter(allEvents, (event: INewGetEventsDetailsResponse) =>
            event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus === 0
            && moment(event?.ToteResponse?.EventDetail?.currentRace?.PostTime+'Z')
              .isSame(today, 'day')
            && convertTimeToMinutes(event?.ToteResponse?.EventDetail?.currentRace?.PostTime+'Z') > 60
            && selectedTrackType(
              event?.ToteResponse?.EventDetail?.TrackType, trackType, event?.CountryCode
            ) === true
            && event?.isFavorite === isFavorite
          ),
          ['ToteResponse.EventDetail.currentRace.PostTime'],
          ['asc']
        ),
        _.orderBy(
          // open - Time - Tomorrow
          _.filter(allEvents, (event: INewGetEventsDetailsResponse) =>
            event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus === 0
            && !moment(event?.ToteResponse?.EventDetail?.currentRace?.PostTime+'Z')
              .isSame(today, 'day')
            && selectedTrackType(
              event?.ToteResponse?.EventDetail?.TrackType, trackType, event?.CountryCode
            ) === true
            && event?.isFavorite === isFavorite
          ),
          ['ToteResponse.EventDetail.currentRace.PostTime'],
          ['asc']
        ),
        _.orderBy(
          // closed
          _.filter(allEvents, (event: INewGetEventsDetailsResponse) =>
            event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus === 1
            && selectedTrackType(
              event?.ToteResponse?.EventDetail?.TrackType, trackType, event?.CountryCode
            ) === true
            && event?.isFavorite === isFavorite
          ),
          ['ToteResponse.EventDetail.currentRace.PostTime'],
          ['asc']
        ),
        _.orderBy(
          // post
          _.filter(allEvents, (event: INewGetEventsDetailsResponse) =>
            event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus === 2
            && selectedTrackType(
              event?.ToteResponse?.EventDetail?.TrackType, trackType, event?.CountryCode
            ) === true
            && event?.isFavorite === isFavorite
          ),
          ['ToteResponse.EventDetail.currentRace.PostTime'],
          ['asc']
        ),
        _.orderBy(
          // final
          _.filter(allEvents, (event: INewGetEventsDetailsResponse) =>
            event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus === 3
            && selectedTrackType(
              event?.ToteResponse?.EventDetail?.TrackType, trackType, event?.CountryCode
            ) === true
            && event?.isFavorite === isFavorite
          ),
          ['ToteResponse.EventDetail.currentRace.PostTime'],
          ['asc']
        ),
        _.orderBy(
          // cancelled
          _.filter(allEvents, (event: INewGetEventsDetailsResponse) =>
            event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus === 4
            && selectedTrackType(
              event?.ToteResponse?.EventDetail?.TrackType, trackType, event?.CountryCode
            ) === true
            && event?.isFavorite === isFavorite
          ),
          ['ToteResponse.EventDetail.currentRace.PostTime'],
          ['asc']
        )
      ) as INewGetEventsDetailsResponse[];

    // separate by favorite
    newListEvent = _.concat(
      ...newListEventFn(true),
      ...newListEventFn(undefined)
    );
  }
  else if (sortBy === 'Name') {
    const newListEventFn = (isFavorite?: boolean) =>
      _.concat(
        _.orderBy(
          // others
          _.filter(allEvents, (event: INewGetEventsDetailsResponse) =>
            event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus !== 3
            && selectedTrackType(
              event?.ToteResponse?.EventDetail?.TrackType, trackType, event?.CountryCode
            ) === true
            && event?.isFavorite === isFavorite
          ),
          [
            (event: INewGetEventsDetailsResponse) =>
              (
                event.CountryCode != null
                && event.CountryCode !== 'US'
                && event.CountryCode !== 'CA'
                && event.CountryCode !== ''
                  ? event.CountryCode
                  : ''
              )
              + event.ToteResponse.EventDetail.EventName
          ],
          ['asc']
        ),
        _.orderBy(
          // final
          _.filter(allEvents, (event: INewGetEventsDetailsResponse) =>
            event?.ToteResponse?.EventDetail?.currentRace?.RaceStatus === 3
            && selectedTrackType(
              event?.ToteResponse?.EventDetail?.TrackType, trackType, event?.CountryCode
            ) === true
            && event?.isFavorite === isFavorite
          ),
          [
            (event: INewGetEventsDetailsResponse) =>
              (
                event.CountryCode != null
                && event.CountryCode !== 'US'
                && event.CountryCode !== 'CA'
                && event.CountryCode !== ''
                  ? event.CountryCode
                  : ''
              )
              + event.ToteResponse.EventDetail.EventName
          ],
          ['asc']
        )
      ) as INewGetEventsDetailsResponse[];

    // separate by favorite
    newListEvent = _.concat(
      ...newListEventFn(true),
      ...newListEventFn(undefined)
    );
  }


  // console.log('sortEvents:allEvents2:', newListEvent);

  return newListEvent;
}
